import { useFirmContext } from '../../../../../providers/FirmProvider';
import AtosaLogo from '../../../../../assets/atosa.png';
import IntegrationOverview from '../../../../../components/integration-overview/IntegrationOverview';
import FirmAtosaIntegration from './FirmAtosaIntegration';
// import FirmFYIIntegration from './FirmFYIIntegration';

type FirmAtosaIntegrationOverviewProps = {
    show: boolean;
};

function FirmAtosaIntegrationOverview({ show }: FirmAtosaIntegrationOverviewProps): JSX.Element | null {
    const {
        integrations: { atosa },
    } = useFirmContext();

    if (!show) {
        return null;
    }

    return (
        <IntegrationOverview
            title="Atosa"
            logo={AtosaLogo}
            active={Boolean(atosa)}
            _new
            description="Connect Atosa to Cimplico Workpapers to prefill calculations with activity statement data."
        >
            <FirmAtosaIntegration />
        </IntegrationOverview>
    );
}

export default FirmAtosaIntegrationOverview;
